import { render } from "./Hint-template-tab.vue?vue&type=template&id=e58f7d70"
import script from "./Hint-template-tab.vue?vue&type=script&lang=js"
export * from "./Hint-template-tab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__